import type { IconName } from '../components/Icon';

export type Channel = 'email' | 'sms' | 'viber';

/**
 * Map a campaign's `channelId` to the UI channel string.
 * Backend convention: 1 = Email (default), 2 = SMS, 3 = Viber.
 */
export function channelOf(c: { channelId?: number }): Channel {
  switch (c.channelId) {
    case 2:
      return 'sms';
    case 3:
      return 'viber';
    default:
      return 'email';
  }
}

export interface ChannelMeta {
  label: string;
  icon: IconName;
  /** className suffix for `.ch-tag` / `.chip-channel` */
  key: Channel;
}

export const CHANNEL_META: Record<Channel, ChannelMeta> = {
  email: { label: 'Email', icon: 'mail', key: 'email' },
  sms: { label: 'SMS', icon: 'sms', key: 'sms' },
  viber: { label: 'Viber', icon: 'viber', key: 'viber' },
};

/** CSS custom-property values for a channel (token-based, no raw hex). */
export function channelVars(ch: Channel): { color: string; soft: string } {
  return { color: `var(--ch-${ch})`, soft: `var(--ch-${ch}-soft)` };
}
